import axios from "axios";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { CiReceipt } from "react-icons/ci";
import { PiCoinsThin } from "react-icons/pi";
import { RiRefund2Line } from "react-icons/ri";
import { useSelector } from "react-redux";
import clientConfig from "../../env";
import { toast } from "react-toastify";

export const Transactions = () => {

  const confirmationCloseRef = useRef(null);
  const userId = useSelector((state) => state.user.userId);
  const userfirstname = useSelector((state) => state.user.firstName);
  const userlastname = useSelector((state) => state.user.lastName);
  const useremail = useSelector((state) => state.user.email);

  const [transactions, setTransactions] = useState([]);
  const [transactionObject, setTransactionObject] = useState(null);

  const getAllTransaction = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.post(
        "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/get-all-transactions.php",
        {
          userId: userId,
        },
        { headers: headers }
      );
      if (
        response.status === 200 &&
        response.data &&
        response.data.transactions.length
      ) {
        setTransactions(response.data.transactions);
      }
    } catch(error) {
      console.log(error)
    }
  }

  useEffect( () => {
    getAllTransaction();
  }, [])

  const handleConfirmationRefund = (e, transactionId, transactionDate, refundAmount) => {
    e.preventDefault();
    setTransactionObject({
      id: transactionId,
      date: transactionDate,
      amount: refundAmount,
    });
  }

  const sendEmailNotification = async () => {
    try {
      console.log("handle Send Email Notification");
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/send-refund-request`,
        {
          username: `${userfirstname} ${userlastname}`,
          email: useremail,
          transaction_id: transactionObject.id,
          transaction_date: transactionObject.date,
          refund_amount: transactionObject.amount,
        },
        {
          headers: headers,
        }
      );

      if (response.status === 200) {
        toast.success(response.data.message);
        await getAllTransaction();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      confirmationCloseRef.current.click();
    }
  }

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      console.log("handle Submit");
      await sendEmailNotification();
      // const headers = {
      //   "Content-Type": "application/json",
      // };
      // const response = await axios.post(
      //   "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/create-refund-request.php",
      //   {
      //     chargeId: transactionId,
      //     userId: userId,
      //   },
      //   {
      //     headers: headers,
      //   }
      // );
      // console.log(response)
      // if(response.status === 200) {
      //   await sendEmailNotification();
      // } else {
      //   toast.error(response.data.message)
      // }
    } catch(error) {
      console.log(error)
    }
  }

  return (
    <>
      <div className="row">
        <div className="col-12 mb-3">
          <h1 className="title mb-0 mt-2">Transactions</h1>
          <p>Manage your transactions and receipts here.</p>
        </div>

        <div className="col-12">
          <div className="table table-striped table-responsive border border-2 transactions-table p-3">
            <table className="table table-borderless m-0">
              <thead>
                <tr>
                  <th scope="col" className="pb-4">
                    Type
                  </th>
                  <th scope="col" className="pb-4" width="200">
                    Date
                  </th>
                  <th scope="col" className="pb-4">
                    Amount
                  </th>
                  <th scope="col" className="pb-4">
                    Account
                  </th>
                  <th scope="col" className="pb-4">
                    Status
                  </th>
                  <th scope="col" className="pb-4" width="180">
                    Receipt
                  </th>
                </tr>
              </thead>
              <tbody>
                {transactions.length ? (
                  transactions.map((item, index) => (
                    <tr key={index}>
                      <td>{item.credit_package ?? "Subscription"}</td>
                      <td>{moment(item.created).format("MMM Do, YYYY")}</td>
                      <td>${item.amount.toFixed(2)}</td>
                      <td>
                        <span className="font-weight-bold">
                          {item?.account?.brand}
                        </span>{" "}
                        {item?.account?.last4}
                      </td>
                      <td
                        className={`text-capitalize ${
                          item.status === "succeeded"
                            ? "text-success"
                            : "text-error"
                        }`}
                      >
                        {item.refunded ? "Refunded" : item.status}
                      </td>

                      <td>
                        <div className="d-flex flex-column">
                          <a
                            href={item.receipt_url}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-primary btn-sm rounded-10"
                          >
                            View Receipt
                          </a>
                          {!item.refunded ? (
                            <button
                              type="button"
                              className="btn btn-link d-inline-block mt-1 btn-sm"
                              data-toggle="modal"
                              data-target="#refundConfirmationModal"
                              onClick={(e) =>
                                handleConfirmationRefund(
                                  e,
                                  item.transaction_id,
                                  item.created,
                                  item.amount.toFixed(2)
                                )
                              }
                            >
                              Refund
                            </button>
                          ) : null}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td align="center" colSpan={6}>
                      No Transaction
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="refundConfirmationModal"
        tabIndex="-1"
        aria-labelledby="jointablemodalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="jointablemodalLabel">
                Refund Confirmation
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                ref={confirmationCloseRef}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p className="m-0 text-left">
                Are you sure you want to request a refund? This will send a
                notification to the admin.
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary rounded-10"
                onClick={handleSubmit}
              >
                Confirm Refund
              </button>
              <button
                id="jointableClosebtn"
                type="button"
                className="btn btn-secondary rounded-10"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
